import * as Yup from 'yup';
import FileUploadInput from 'src/components/FileUploadInput';
import { SxProps } from 'src/theme/types/sxProps';
import ReadonlyField from 'src/components/ReadonlyField';
import { TextField } from '@mui/material';
import Select from 'src/components/Select';
import { ALLOWED_EXTENSION } from '../SolutionDeviceConfig/constants';
import { SolutionAssetDashboardField, SolutionAssetTwinField } from '../types';

const inputStyle: SxProps = { width: ({ spacing }) => spacing(42) };

const fileInputField = {
  Component: FileUploadInput,
  type: 'file',
  required: true,
  validation: Yup.mixed()
    .required('A file is required')
    .test(
      'fileFormat',
      ({ value }) =>
        `This file (${value?.name}) type is not supported. Only ${ALLOWED_EXTENSION} are allowed.`,
      (value) => value?.type === ALLOWED_EXTENSION
    ),
};

export const uploadFormFields = [
  {
    name: 'SerializedJsonModel',
    label: 'Upload JSON Files',
    ...fileInputField,
  },
];

const assetModelFileInputField = {
  Component: FileUploadInput,
  type: 'file',
  required: true,
  validation: Yup.mixed()
    .required('A file is required')
};

export const uploadModelFormFields = [
  {
    name: 'file',
    label: 'Upload file',
    ...assetModelFileInputField,
  },
];

const uploadTwinData = {
  Component: FileUploadInput,
  type: 'file',
};

export const addTwinFormFields = (
  getOptions: { value: string; label: string }[] | undefined,
  level: number,
  defaultTemplate: any,
  isISA95Standard?: boolean
) => [
  {
    name: SolutionAssetTwinField.twinId,
    label: 'Name',
    Component: TextField,
    placeholder: 'Enter name',
    required: true,
    validation: Yup.string()
      .matches(/^\S*$/, 'Spaces are not allowed')
      .required('Name is required'),
    sx: inputStyle,
  },
  !isISA95Standard || (isISA95Standard && level > 3)
    ? {
        name: SolutionAssetTwinField.modelId,
        label: 'Model',
        Component: Select,
        placeholder: 'Select the option',
        required: true,
        validation: Yup.string().required('Model is required'),
        options: getOptions,
        sx: inputStyle,
      }
    : {
        name: SolutionAssetTwinField.modelId,
        label: 'Model',
        Component: ReadonlyField,
        displayValue: true,
        labelStyle: { fontWeight: 'bold', flex: 1, paddingLeft: '4px' },
        value: defaultTemplate[level],
        sx: { width: ({ spacing }) => spacing(34) },
      },
  {
    name: 'TwinData',
    label: 'Upload Twin Data',
    ...uploadTwinData,
  },
];

export const createDashboardFormFields = [
  {
    name: SolutionAssetDashboardField.Name,
    label: 'Name',
    Component: TextField,
    placeholder: 'Enter dashboard name',
    required: true,
    validation: Yup.string().required('Dashboard name is required'),
    sx: inputStyle,
  },
  {
    name: SolutionAssetDashboardField.Description,
    label: 'Description',
    Component: TextField,
    placeholder: 'Enter description',
    multiline: true,
    rows: 3,
    sx: inputStyle,
  },
];
